import { Donor } from './donor';
import { Recipient } from './recipient';
export enum Reason {
  DONORAGEDIFF = 'Donor not accepted (age difference)',
  DONORRENALFUNCTION = 'Donor not accepted (renal function)',
  DONORTYPINGMISMATCH = 'Donor not accepted (typing mismatch)',
  DONORVASCULARPROBLEMS = 'Donor not accepted (vascular problems)',
  IMMUNOLOGICAL = 'Immunologically not accepted',
  ORGANISATIONPROBLEMS = 'Organizational problems',
  OTHER = 'Other Reason'
}

export interface Crossmatch {
  id: string;
  donorEnis: string;
  recipientEnis: string;
  donor?: Donor; // Nullable: may not exist if participant was deleted
  recipient?: Recipient; // Nullable: may not exist if participant was deleted
  positive?: boolean;
  userCreated: string;
  dateCreated: Date;
  reasonExcluded?: Reason;
  sampleDate?: string;
  resultDate?: string;
  excluded: boolean;
  comments?: string;
}

export const ReasonLabels: Record<Reason, string> = {
  [Reason.DONORAGEDIFF]: 'Donor not accepted (age difference)',
  [Reason.DONORRENALFUNCTION]: 'Donor not accepted (renal function)',
  [Reason.DONORTYPINGMISMATCH]: 'Donor not accepted (typing mismatch)',
  [Reason.DONORVASCULARPROBLEMS]: 'Donor not accepted (vascular problems)',
  [Reason.IMMUNOLOGICAL]: 'Immunologically not accepted',
  [Reason.ORGANISATIONPROBLEMS]: 'Organizational problems',
  [Reason.OTHER]: 'Other Reason'
};
